import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureAppStore from './store/configureStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'bootstrap/dist/js/bootstrap';
import { socket, SocketContext } from './socket/socketio';
const store = configureAppStore();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render
(
  <Provider store={store}>
    <SocketContext.Provider value={socket}>
    <App />
    </SocketContext.Provider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();